require('./ImmediateBox.scss');

// @vendor
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

const { FormattedText, formatText } = require('core/i18n').i18n;
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKBoxOptions } = require('commonsComponents/OKBoxOptions');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('commonsComponents/OKButton');
const classNames = require('classnames');

// @constants
const {
    IMMEDIATE_FREE,
    IMMEDIATE_NOT_FREE
} = require('constants/index');

import image1 from 'assets/images/immediateBox/image1.png';
import image2 from 'assets/images/immediateBox/image2.png';

class ImmediateBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openModalImmediate: false,
            modalType: IMMEDIATE_FREE,
        }
    }

    handleModalInformationImmediate = (openModalImmediate, modalType) => {
        this.setState({
            openModalImmediate,
            modalType
        });
    }

    buildImmediateFailureMessage = () => {
        const { isImmediateFailure } = this.props;

        if (isImmediateFailure) {
            return (
                <div className="immediate-box__container">
                    <b>
                        <FormattedText value="transferSummary-failureTitle" />
                    </b>
                </div>
            )
        }

        return null
    }

    buildImmediateFetchingMessage = () => {
        const { isImmediateFailure, isImmediateFetching } = this.props;

        if (isImmediateFetching && !isImmediateFailure) {
            return (
                <LoadingSection />
            )
        }

        return null
    }

    changeTransferMethod = (option) => {
        if(option) {
            const { actions } = this.props;
            const isImmmediate = option.item === "IMMEDIATE";

            actions.handleImmediateTransfer(isImmmediate)
        }
    }

    buildFooterBox = (type, showButton) => {
        const {
            immediateAmount,
            currencySymbol,
        } = this.props;

        const valueImmediateTransfer = type === IMMEDIATE_FREE || immediateAmount === 0 ? formatText('transferImmediate-free') : `${immediateAmount} ${currencySymbol}`

        const firstOptionFooterClass = classNames('immediate-box__info', {
            'col-xs-6': showButton,
            'col-xs-12': !showButton
        });

        const secondOptionFooterClass = classNames('immediate-box__button', {
            'col-xs-6': !showButton,
            'col-xs-12 -left': showButton
        })

        return (
            <div className="row immediate-box">
                <div className={firstOptionFooterClass}>
                    {!showButton && <Fragment>
                        <span><FormattedText value="transferImmediate-cost" /></span>{' '}<span className="immediate-box__info__value">{valueImmediateTransfer}</span>
                    </Fragment>}
                </div>
                <div className={secondOptionFooterClass}>
                    {showButton && <OKButton modifier="link-complementary" target="_blank" onClick={() => this.handleModalInformationImmediate(true, type)}>
                        <FormattedText value="transferImmediate-moreInformation" />
                    </OKButton>}
                </div>
            </div>
        )
    }

    buildImmediateSuccessMessage = () => {
        const {
            isImmediate,
            immediateTransfersEnabled,
            isImmediateFailure,
            isImmediateFetching,
            doTransferImmediate
        } = this.props;

        const options = [
            {   item: "STANDARD",
                titleOption: formatText('transferImmediate-standardType'),
                descriptionOption: <FormattedText value="transferImmediate-standardTypeDescription" />,
                image: image1,
                footerContentOption: this.buildFooterBox(IMMEDIATE_FREE, false),
                selected: !doTransferImmediate
            },
            {
                item: "IMMEDIATE",
                titleOption: formatText('transferImmediate-immediateType'),
                descriptionOption: <FormattedText value="transferImmediate-immediateTypeDescription" />,
                image: image2,
                footerContentOption: this.buildFooterBox(IMMEDIATE_NOT_FREE, true),
                selected: doTransferImmediate
            }
        ];

        if (isImmediate && immediateTransfersEnabled && !isImmediateFetching && !isImmediateFailure) {
            return (
                <OKBoxOptions
                    options={options}
                    optionSelected={[options.find(option => option.selected) || options[0]]}
                    callbackOnClick={this.changeTransferMethod}
                    rowItems={2}
                    itemCompareSelected={'item'}
                />
            )
        }

        return null;
    }

    buildModal = () => {
        const { openModalImmediate, modalType } = this.state;

        return(
            <ModalCustom
                isOpen={openModalImmediate}
                onRequestClose={() => this.handleModalInformationImmediate(false)}
            >
                <div className="modal-immediate-box">
                    <h1 className="modal-immediate-box__title">
                        <b>
                            <FormattedText
                                value={
                                    modalType === IMMEDIATE_FREE ? 'transferSummary-titleModalTransferFree' : 'transferSummary-titleModalImmediate'
                                }
                            />
                        </b>
                    </h1>
                    <FormattedText
                        value={
                            modalType === IMMEDIATE_FREE ? 'transferSummary-firstDescriptionModalTransferFree' : 'transferSummary-firstDescriptionModalImmediate'
                        }
                    />
                </div>
            </ModalCustom>
        )
    }

    render() {
        const messageFailure = this.buildImmediateFailureMessage();
        const messageLoading = this.buildImmediateFetchingMessage();
        const messageSuccess = this.buildImmediateSuccessMessage();
        const modal = this.buildModal();

        return (
            <Fragment>
                {messageFailure}
                {messageLoading}
                {messageSuccess}
                {modal}
            </Fragment>
        );
    }
}

ImmediateBox.propTypes = {
    isImmediate: PropTypes.bool.isRequired,
    immediateTransfersEnabled: PropTypes.bool.isRequired,
    isImmediateFailure: PropTypes.bool.isRequired,
    isImmediateFetching: PropTypes.bool.isRequired,
    immediateAmount: PropTypes.number.isRequired,
    currencySymbol: PropTypes.string.isRequired,
    doTransferImmediate: PropTypes.bool.isRequired,
    immTransferState: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

ImmediateBox.defaultProps = {
    isImmediate: false,
    immediateTransfersEnabled: false,
    isImmediateFailure: false,
    isImmediateFetching: false,
    immediateAmount: 0,
    currencySymbol: 'EUR',
    doTransferImmediate: false,
    immTransferState: {},
    actions: {}
};

export { ImmediateBox };
